import * as MsComponents from './components';

const SmartlyVue = {
  install(Vue) {
    Object.values(MsComponents).forEach((Component) => {
      Vue.component(Component.name, Component);
    });
  },
};

export default SmartlyVue;
export * from './components';
